import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, makeStyles, Grid, Button, SvgIcon, Card } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { PlusCircle as PlusIcon } from 'react-feather';
import { Rss as RssIcon } from 'react-feather';
import { useSelector } from 'react-redux';
import { TAGS_LIST_API, USER_THREADS_TIMELINE_API } from 'src/Api/Community/Index';
import { Chip } from '@mui/material';
import { Link, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles(() => ({
  root: {}
}));

const ThreadFilter = ({className,pagination, ...rest }) => {
  const classes = useStyles();
  const {authData}=useSelector((state)=>state.authData);
  const {threadData}=useSelector((state)=>state.threadData);

  const [tags, setTags] = useState([]); 
  const [FilterTag,setFilterTag] = useState('');
  const {exam_slug}=useParams();
  const location = useLocation();

  const getTags = (async () => {
    try {       
      const {data}=await TAGS_LIST_API() 
      const {status,tags,message,count}=data;
      if(status){               
        setTags(tags);
      }else{
        setTags([]);        
      }
    }catch (err) {
      console.error(err);
    }
  }); 
  const setSelectedTagUsingUrl=async()=>{
    const queryParams = new URLSearchParams(location.search);
    const tagValue = queryParams.get('tag');
    if(tagValue){        
      setFilterTag(tagValue);
    }else{
      setFilterTag('')
    }
    if(pagination){
      // console.log(threadData);
    }
    // console.log('pagination',pagination);
  }

  useEffect(() => {
    getTags(); 
  }, []);

  useEffect(() => {
    setSelectedTagUsingUrl();
  }, [location.search]); 
  
  const handleTagFilter=(tag)=>{
    // if(tag){
    //     setSelectedSort(tag)
    // }else{
    //     setSelectedSort('')
    // }
  }

  const row={
    "display": "flex",
    "gap": "10px",
    "flexWrap": "wrap",
  }
  return (
    <>
    <div
      className={clsx(classes.root, className)}
      style={{ padding: '22px', background: 'linear-gradient(151deg, rgba(121,161,255,1) 0%, rgba(82,97,198,1) 35%, rgba(56,73,230,1) 100%)' }}
      {...rest}
    >
      <Grid container spacing={1} style={row}>
        <Chip
            onClick={()=>handleTagFilter('')}    
            color="default"
            size="small"
            label="ALL THREADS"
            component={Link}
            to={`/${exam_slug}/app/threads/browse`}
            variant={FilterTag?"outlined":''}
            clickable
            sx={{color:"white"}}
        />
        {
            tags.map((tag)=>{
                return (
                    <Chip
                        key={tag._id}
                        onClick={()=>handleTagFilter(tag._id??'')}                        
                        // color='success'
                        size="small"
                        sx={{color:"white"}}
                        label={tag.title}
                        component={Link}                        
                        to={`/${exam_slug}/app/threads/browse?tag=${tag._id}`}
                        variant={FilterTag===tag._id?"":'outlined'}
                        clickable
                    />
                );
            })
        }
    </Grid>
    </div>
    </>
  );
};

ThreadFilter.propTypes = {
  className: PropTypes.string
};

export default ThreadFilter;
